// 
// Ecommlab Product Details Table
// - 
// 
document.addEventListener('DOMContentLoaded', function() {
  productDetailsTable();

  function productDetailsTable(){

    document.addEventListener('variant:change', function(event) {
      let variant = event.detail.variant;
      updateDetailsTable(variant.id);
    });

    function updateDetailsTable(variantId){
      let detailValues = document.querySelectorAll('.details-table-variant');
      detailValues.forEach(function(item){
        item.classList.add('hide');
      });
 
      let detailImages = document.querySelectorAll('.details-table-image');
      detailImages.forEach(function(item){
        item.classList.add('hide');
      });

      let detailHeadings = document.querySelectorAll('.details-table-heading-variant');
      detailHeadings.forEach(function(item){
        item.classList.add('hide');
      });


      let selectedVariantValue = document.querySelector(`.details-table-variant[data-variant-id="${variantId}"]`);
      let selectedVariantImage = document.querySelector(`.details-table-image[data-variant-id="${variantId}"]`);
      let selectedVariantHeadings = document.querySelectorAll(`.details-table-heading-variant[data-variant-id="${variantId}"]`);
      
      selectedVariantValue.classList.remove('hide');
      selectedVariantImage.classList.remove('hide');
      selectedVariantHeadings.forEach(function(heading){
        if (heading.getAttribute('data-default-variant') == 'false') {
          heading.classList.remove('hide');
        }        
      });
    }

    
  }
});